import ProfileTabs from './profile-tabs';

export default ProfileTabs;